import { ReadingTimeStats } from '@models/shared/readingTimeStats.type.interface';
import { IStatusType } from '@models/shared/status.type.interface';

export class Blog {
  _id!: string;
  author?: string;
  asCat?: null | number;
  categories?: any;
  catName?: string;
  excerpt?: string;
  meta_description?: string;
  title_tag?: string; // SEO
  modified: any;
  id?: number;
  date?: string;
  publish_date?: string;
  content?: any;
  metaTitle?: string; // SEO
  metaDesc?: string; // SEO
  title?: string;
  slug!: string;
  newSlug?: string;
  lastModifiedAt?: string;
  viewCount?: number;
  imgUrl?: string;
  readingTimeStats?: ReadingTimeStats;
  mainCategory?: { slug: string };
  subCategory?: { slug: string };
  status?: IStatusType;

  constructor(data: any = null) {
    Object.assign(this, data);
  }
}
